// Comprehensive language list with ISO codes, native names, and text direction
// Used for dynamic AI-powered translation
export const SUPPORTED_LANGUAGES = [
  { code: "ar", label: "Arabic", nativeName: "العربية", dir: "rtl", flag: "🇸🇦" },
  { code: "en", label: "English", nativeName: "English", dir: "ltr", flag: "🇬🇧" },
  { code: "fr", label: "French", nativeName: "Français", dir: "ltr", flag: "🇫🇷" },
  { code: "es", label: "Spanish", nativeName: "Español", dir: "ltr", flag: "🇪🇸" },
  { code: "de", label: "German", nativeName: "Deutsch", dir: "ltr", flag: "🇩🇪" },
  { code: "it", label: "Italian", nativeName: "Italiano", dir: "ltr", flag: "🇮🇹" },
  { code: "pt", label: "Portuguese", nativeName: "Português", dir: "ltr", flag: "🇵🇹" },
  { code: "ru", label: "Russian", nativeName: "Русский", dir: "ltr", flag: "🇷🇺" },
  { code: "tr", label: "Turkish", nativeName: "Türkçe", dir: "ltr", flag: "🇹🇷" },
  { code: "zh", label: "Chinese (Simplified)", nativeName: "简体中文", dir: "ltr", flag: "🇨🇳" },
  { code: "ja", label: "Japanese", nativeName: "日本語", dir: "ltr", flag: "🇯🇵" },
  { code: "ko", label: "Korean", nativeName: "한국어", dir: "ltr", flag: "🇰🇷" },
  { code: "hi", label: "Hindi", nativeName: "हिन्दी", dir: "ltr", flag: "🇮🇳" },
  { code: "ur", label: "Urdu", nativeName: "اردو", dir: "rtl", flag: "🇵🇰" },
  { code: "fa", label: "Persian", nativeName: "فارسی", dir: "rtl", flag: "🇮🇷" },
  { code: "he", label: "Hebrew", nativeName: "עברית", dir: "rtl", flag: "🇮🇱" },
  { code: "nl", label: "Dutch", nativeName: "Nederlands", dir: "ltr", flag: "🇳🇱" },
  { code: "pl", label: "Polish", nativeName: "Polski", dir: "ltr", flag: "🇵🇱" },
  { code: "sv", label: "Swedish", nativeName: "Svenska", dir: "ltr", flag: "🇸🇪" },
  { code: "no", label: "Norwegian", nativeName: "Norsk", dir: "ltr", flag: "🇳🇴" },
  { code: "da", label: "Danish", nativeName: "Dansk", dir: "ltr", flag: "🇩🇰" },
  { code: "fi", label: "Finnish", nativeName: "Suomi", dir: "ltr", flag: "🇫🇮" },
  { code: "el", label: "Greek", nativeName: "Ελληνικά", dir: "ltr", flag: "🇬🇷" },
  { code: "cs", label: "Czech", nativeName: "Čeština", dir: "ltr", flag: "🇨🇿" },
  { code: "ro", label: "Romanian", nativeName: "Română", dir: "ltr", flag: "🇷🇴" },
  { code: "hu", label: "Hungarian", nativeName: "Magyar", dir: "ltr", flag: "🇭🇺" },
  { code: "uk", label: "Ukrainian", nativeName: "Українська", dir: "ltr", flag: "🇺🇦" },
  { code: "id", label: "Indonesian", nativeName: "Bahasa Indonesia", dir: "ltr", flag: "🇮🇩" },
  { code: "ms", label: "Malay", nativeName: "Bahasa Melayu", dir: "ltr", flag: "🇲🇾" },
  { code: "th", label: "Thai", nativeName: "ไทย", dir: "ltr", flag: "🇹🇭" },
  { code: "vi", label: "Vietnamese", nativeName: "Tiếng Việt", dir: "ltr", flag: "🇻🇳" },
  { code: "sw", label: "Swahili", nativeName: "Kiswahili", dir: "ltr", flag: "🇰🇪" },
  { code: "bn", label: "Bengali", nativeName: "বাংলা", dir: "ltr", flag: "🇧🇩" },
  { code: "ta", label: "Tamil", nativeName: "தமிழ்", dir: "ltr", flag: "🇮🇳" },
];

export const getLanguageMeta = (code) =>
  SUPPORTED_LANGUAGES.find((l) => l.code === code) || SUPPORTED_LANGUAGES[1];
